import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { CapabilityApiActions } from "../actions";
import { ICapability } from "@skills-app/models/capability";
import { ILead } from "@skills-app/models/capabilityLead";
import { ISkillGroup } from "@skills-app/models/skillGroup";
import { NavmenuActions } from "@skills-app/core/actions";

export interface ICapabilitiesState {
  capabilities: ICapability[];
  filteredConsultants: ILead[];
  selectedCapability: ICapability | null;
  selectedCapabilitySkillGroups: ISkillGroup[];
}

const initialState: ICapabilitiesState = {
  capabilities: [],
  filteredConsultants: [],
  selectedCapability: null,
  selectedCapabilitySkillGroups: [],
};

export const reducer = createReducer(
  initialState,

  on(CapabilityApiActions.populateCapabilities, (state, action) => ({
    ...state,
    capabilities: action.capabilities,
  })),

  on(CapabilityApiActions.populateFilterResults, (state, action) => ({
    ...state,
    filteredConsultants: action.consultants,
  })),

  on(CapabilityApiActions.getCapabilitySuccess, (state, action) => ({
    ...state,
    selectedCapability: action.capability,
  })),

  on(CapabilityApiActions.getCapabilityFailure, (state) => ({
    ...state,
    selectedCapability: null,
  })),

  on(
    CapabilityApiActions.getSkillGroupsForSelectedCapabilitySuccess,
    (state, action) => ({
      ...state,
      selectedCapabilitySkillGroups: action.skillGroups,
    }),
  ),

  on(
    CapabilityApiActions.getSkillGroupsForSelectedCapabilityFailure,
    (state) => ({
      ...state,
      selectedCapabilitySkillGroups: [],
    }),
  ),

  on(NavmenuActions.endNavigation, (state) => ({
    ...state,
    selectedCapability: null,
    selectedCapabilitySkillGroups: [],
  })),
);

export const getCapabilitiesState =
  createFeatureSelector<ICapabilitiesState>("capabilities");

export const getCapabilities = createSelector(
  getCapabilitiesState,
  (capabilitiesState) => capabilitiesState.capabilities,
);

export const getSelectedCapability = createSelector(
  getCapabilitiesState,
  (capabilitiesState) => capabilitiesState.selectedCapability,
);

export const getFilteredConsultants = createSelector(
  getCapabilitiesState,
  (capabilitiesState) => capabilitiesState.filteredConsultants,
);

export const getSelectedCapabilitySkillGroups = createSelector(
  getCapabilitiesState,
  (capabilitiesState) => capabilitiesState.selectedCapabilitySkillGroups,
);
